/**
 * Volix Product Gallery - Mobile Scroll Fix
 * The AI product block uses overflow-x:auto which blocks page scroll.
 * This script replaces scroll-based gallery with show/hide on mobile.
 */
(function () {
  'use strict';
  if (!document.body.classList.contains('product')) return;
  if (window.innerWidth >= 750) return;

  document.addEventListener('DOMContentLoaded', function () {
    var galleryScroll = document.querySelector('[class*="ai-huda-product-gallery-scroll-"]');
    if (!galleryScroll) return;

    var items = Array.from(galleryScroll.querySelectorAll('[class*="ai-huda-product-gallery-item-"]'));
    var dotsContainer = document.querySelector('[class*="ai-huda-product-gallery-dots-"]');

    if (items.length === 0) return;

    var currentIndex = 0;

    function showItem(index) {
      items.forEach(function (item) {
        item.classList.add('volix-hidden');
        item.classList.remove('volix-active');
      });
      if (items[index]) {
        items[index].classList.remove('volix-hidden');
        items[index].classList.add('volix-active');
      }
      currentIndex = index;

      if (dotsContainer) {
        var dots = dotsContainer.querySelectorAll('button');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('active', i === index);
        });
      }
    }

    // Initialize: show first item
    showItem(0);

    // Override dot clicks
    if (dotsContainer) {
      var dots = Array.from(dotsContainer.querySelectorAll('button'));
      dots.forEach(function (dot, i) {
        var newDot = dot.cloneNode(true);
        dot.parentNode.replaceChild(newDot, dot);
        newDot.addEventListener('click', function () {
          showItem(i);
        });
      });
    }

    // Touch swipe support (left/right)
    var startX = 0, startY = 0;

    galleryScroll.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    galleryScroll.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      var dy = Math.abs(e.changedTouches[0].clientY - startY);

      // Only horizontal swipe (more horizontal than vertical, at least 40px)
      if (Math.abs(dx) > dy && Math.abs(dx) > 40) {
        if (dx < 0 && currentIndex < items.length - 1) {
          showItem(currentIndex + 1);
        } else if (dx > 0 && currentIndex > 0) {
          showItem(currentIndex - 1);
        }
      }
    }, { passive: true });
  });
})();
